import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";

export default function BackLink({ to = "/", children = "Back to home", className, ...props }) {
    return (
        <Link
            to={to}
            className={cn(
                "inline-flex items-center gap-1.5 text-sm font-medium text-[#8A8178] transition-colors hover:text-[#C9A227]",
                className,
            )}
            {...props}
        >
            <ArrowLeft className="size-3.5 shrink-0" aria-hidden />
            {children}
        </Link>
    );
}
